module.exports = {
  "PUBLIC_ANDROID_APP_ID": "com.huguenot.treefort",
  "PUBLIC_API_DOMAIN_NAME": "api.heritagehuguenot.com",
  "PUBLIC_API_DOMAIN_NAME_WEB": "api.treefortsystems.com",
  "PUBLIC_API_ENDPOINT": "",
  "PUBLIC_APPLE_ID": "6483496094",
  "PUBLIC_APP_ID": "247",
  "PUBLIC_APP_NAME": "Heritage Huguenot",
  "PUBLIC_AUTH_DOMAIN_NAME": "auth.treefortsystems.com",
  "PUBLIC_AUTH_ENDPOINT": "https://app.heritagehuguenot.com",
  "PUBLIC_CDN_ENDPOINT": "https://cdn2.treefortsystems.com",
  "PUBLIC_CLIENT_ID_WEB": "6b4de80f-6547-4263-8a0a-1107acaac147",
  "PUBLIC_DEBUG": "",
  "PUBLIC_DOMAIN_NAME": "app.heritagehuguenot.com",
  "PUBLIC_EAS_PROJECT_ID": "713ac9a1-615c-4a21-ab3f-97c760c3feca",
  "PUBLIC_EAS_UPDATE_CHANNEL": "prd_huguenot",
  "PUBLIC_ENV": "production",
  "PUBLIC_FIREBASE_CONFIG_WEB": "eyJhcHBJZCI6IjE6OTE2NjM5ODcyMzg4OndlYjpmZjA5MjhiODE4ZWI5ZjQyMTJkOWQxIiwiYXBpS2V5IjoiQUl6YVN5QUd3SUpQbjZDSkJ6Tmp6NG5KS01QejNwclJfajBfUlBzIiwicHJvamVjdElkIjoiaGVyaXRhZ2UtaHVndWVub3QtZGQ3NzYiLCJhdXRoRG9tYWluIjoiaGVyaXRhZ2UtaHVndWVub3QtZGQ3NzYuZmlyZWJhc2VhcHAuY29tIiwibWVhc3VyZW1lbnRJZCI6IkctNEczMzdSODcxVyIsInN0b3JhZ2VCdWNrZXQiOiJoZXJpdGFnZS1odWd1ZW5vdC1kZDc3Ni5hcHBzcG90LmNvbSIsIm1lc3NhZ2luZ1NlbmRlcklkIjoiOTE2NjM5ODcyMzg4In0=",
  "PUBLIC_FIREBASE_MESSAGING_VAPID_PUBLIC_KEY": "BFV68D1gUo5igbBc4892Q3sp4uK0R7QfYRH1bA9JevD_ggUL2M7COEey4pSiLeBDlMm-G7pOlSgX9eH_ccOpMEE",
  "PUBLIC_GOOGLE_SITE_VERIFICATION_TOKEN": "",
  "PUBLIC_ICON_BACKGROUND_COLOR": "#1782d9",
  "PUBLIC_ICON_FOREGROUND_IMAGE_PADDING": "23",
  "PUBLIC_ICON_FOREGROUND_IMAGE_URL": "https://cdn2.treefortsystems.com/public/9b87ce32-788a-4102-b99c-106e4254c3fc/uploads/cf5c043a-c1cb-4c4a-871e-8bf52c0dd6f4.png",
  "PUBLIC_IOS_BUNDLE_ID": "com.huguenot.treefort",
  "PUBLIC_MANIFEST_URL": "",
  "PUBLIC_META_PIXEL_ID": "",
  "PUBLIC_OBJECT_STORAGE_CDN_ENDPOINT": "https://cdn.treefortsystems.com/file/treefort-ott-prod",
  "PUBLIC_PASSWORDLESS": "disabled",
  "PUBLIC_PAYMENT_FREEDOM_GRANTED_WEB": "true",
  "PUBLIC_REGION_ENDPOINT": "https://media.treefortsystems.com/region",
  "PUBLIC_RUDDERSTACK_WRITE_KEY_WEB": "2eLoGaZ9sxMEse5uAnt88g56eFZ",
  "PUBLIC_SENTRY_DSN_WEB": "https://2a13400a30ad4037a8f0cf127af14bff@o1003299.ingest.sentry.io/5966172",
  "PUBLIC_SENTRY_ENABLE_EVENTS": "true",
  "PUBLIC_SENTRY_PROFILES_SAMPLE_RATE": "0.5",
  "PUBLIC_SENTRY_TRACES_SAMPLE_RATE": "0.005",
  "PUBLIC_SINGULAR_APP_ID_WEB": "",
  "PUBLIC_SINGULAR_SDK_KEY": "",
  "PUBLIC_SINGULAR_SDK_SECRET": "",
  "PUBLIC_SPLASH_BACKGROUND_COLOR": "",
  "PUBLIC_SPLASH_LOGO_URL": "",
  "PUBLIC_SPLASH_LOGO_WIDTH": "",
  "PUBLIC_SPLASH_SCREEN_BACKGROUND_COLOR": "#1782d9",
  "PUBLIC_SPLASH_SCREEN_FOREGROUND_IMAGE_URL": "https://cdn2.treefortsystems.com/public/9b87ce32-788a-4102-b99c-106e4254c3fc/uploads/13092291-d235-4f58-9121-08cbc8f3bef7.png",
  "PUBLIC_SPLASH_SCREEN_FOREGROUND_IMAGE_WIDTH": "147",
  "PUBLIC_TENANT_ID": "9b87ce32-788a-4102-b99c-106e4254c3fc",
  "PUBLIC_MAJOR_VERSION": "33",
  "PUBLIC_MINOR_VERSION": "5",
  "PUBLIC_PATCH_VERSION": "1",
  "PUBLIC_SENTRY_DIST": "v0",
  "PUBLIC_SENTRY_RELEASE_WEB": "app.heritagehuguenot.com@33.5.1",
  "PUBLIC_SPLASH_SCREEN_DISPLAY_MODE": "light"
}
